
import i18next from 'i18next';
const modal = document.querySelector('#form-result-modal');
const title = modal?.querySelector('[data-result-title]');
const description = modal?.querySelector('[data-result-description]');
const actionButton = modal?.querySelector('[data-result-action]');
const closeButton = modal?.querySelector('[data-modal-close]');
const contactForm = document.querySelector('#contactForm');

const states = {
  success: {
    titleKey: 'formResult.success.title',
    titleFallback: 'Дякуємо! Заявку отримано',

    descriptionKey: 'formResult.success.description',
    descriptionFallback:
      'Ми вже отримали ваші контактні дані. Наш спеціаліст зв’яжеться з вами протягом 10 хвилин у робочий час.',

    actionKey: 'formResult.success.action',
    actionFallback: 'Зрозуміло',
  },

  error: {
    titleKey: 'formResult.error.title',
    titleFallback: 'Упс! Щось пішло не так 😔',

    descriptionKey: 'formResult.error.description',
    descriptionFallback:
      'Спробуйте надіслати заявку ще раз. Якщо помилка повториться, зв’яжіться з нами по телефону.',

    actionKey: 'formResult.error.action',
    actionFallback: 'Спробувати ще раз',
  },
};

function translate(key, fallback) {
  if (!i18next.isInitialized) {
    return fallback;
  }

  return i18next.t(key, {
    defaultValue: fallback,
  });
}

function renderModal(state) {
  const content = states[state];

  if (
    !modal ||
    !title ||
    !description ||
    !actionButton ||
    !closeButton ||
    !content
  ) {
    return;
  }

  modal.dataset.state = state;

  title.textContent = translate(content.titleKey, content.titleFallback);

  description.textContent = translate(
    content.descriptionKey,
    content.descriptionFallback
  );

  actionButton.textContent = translate(
    content.actionKey,
    content.actionFallback
  );

  closeButton.setAttribute(
    'aria-label',
    translate('formResult.closeAria', 'Закрити повідомлення')
  );
}

export function showFormResult(state) {
  if (!modal || !states[state]) {
    return;
  }

  renderModal(state);

  if (!modal.open) {
    modal.showModal();
  }
}

function closeModal() {
  if (modal?.open) {
    modal.close();
  }
}

closeButton?.addEventListener('click', closeModal);

actionButton?.addEventListener('click', () => {
  if (!modal) {
    return;
  }

  const shouldReturnToForm = modal.dataset.state === 'error';

  closeModal();

  if (shouldReturnToForm) {
    requestAnimationFrame(() => {
      contactForm
        ?.querySelector('input, textarea, button[type="submit"]')
        ?.focus();
    });
  }
});


modal?.addEventListener('click', event => {
  if (event.target === modal) {
    closeModal();
  }
});


i18next.on('languageChanged', () => {
  if (modal?.open) {
    renderModal(modal.dataset.state);
  }
});



if (import.meta.env.DEV) {
  window.showFormResult = showFormResult;
}